// ============================================
// Shared types + DragId helpers for LayerPanel
// ============================================

export interface LayerTreeItem {
  kind: 'node' | 'textblock' | 'textlabel' | 'group' | 'sprite' | 'image' | 'blocknode' | 'shape' | 'adr-trigger';
  id: string;
  label: string;
  layerId: string;
  children?: LayerTreeItem[];
  collapsed?: boolean;
  /** ADR IDs linked to this trigger (only for kind === 'adr-trigger') */
  adrIds?: string[];
}

export function encodeDragId(kind: string, id: string): string {
  return `${kind}:${id}`;
}

export function parseDragId(dragId: string): { kind: string; id: string } {
  const idx = dragId.indexOf(':');
  return { kind: dragId.slice(0, idx), id: dragId.slice(idx + 1) };
}

export function parseReorderId(dropId: string): { kind: string; id: string } | null {
  // Format: reorder:kind:id
  if (!dropId.startsWith('reorder:')) return null;
  const rest = dropId.slice('reorder:'.length);
  const idx = rest.indexOf(':');
  if (idx === -1) return null;
  return { kind: rest.slice(0, idx), id: rest.slice(idx + 1) };
}
